import { Box, Typography } from "@mui/material";

import { ControlledSelect, makeSxStyles } from "ui";
import { AdminPatchRouteStartTimeReqDto } from "service/api/estabrookSchemas";
import { FormikErrors } from "formik";
import { generateHourOptions } from "../../../../utils/date-time";
import { RouteStatus } from "../helpers/route-status.enum";

interface BulkEditStartTimeFormProps {
  values: AdminPatchRouteStartTimeReqDto;
  setFieldValue: (field: string, value: any) => void;
  setFieldTouched: (field: string, isTouched: boolean) => void;
  handleBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  validateForm: (
    values?: AdminPatchRouteStartTimeReqDto | undefined,
  ) => Promise<FormikErrors<AdminPatchRouteStartTimeReqDto>>;
  currentRouteStatus?: RouteStatus;
}

const BulkEditStartTimeForm: React.FC<BulkEditStartTimeFormProps> = ({
  values,
  setFieldValue,
  setFieldTouched,
  handleBlur,
  validateForm,
  currentRouteStatus,
}) => {
  const styles = useStyles();

  // Determine when to restrict past times based on route phase
  // In planning phase: allow all times (no restrictions)
  // In planned/live phases: restrict past times (user can only select future times)
  const shouldRestrictPastTimes = () => {
    return currentRouteStatus !== RouteStatus.Planning;
  };

  const hourOptions = generateHourOptions(shouldRestrictPastTimes(), 30);

  return (
    <Box sx={styles.changeStartTimeContainer}>
      <Typography fontWeight={500} sx={styles.label}>
        Change start time for all routes to
      </Typography>
      <ControlledSelect
        value={values.startTime || ""}
        onChange={(value) => {
          setFieldTouched("startTime", true);
          setFieldValue("startTime", value);
          validateForm({ startTime: value });
        }}
        placeholderSelectEnabled={false}
        onBlur={handleBlur}
        options={hourOptions}
        placeholder="Select Time"
        variant="outlined"
        maxHeight={216}
      />
    </Box>
  );
};

const useStyles = makeSxStyles(({ palette: { grey } }) => ({
  changeStartTimeContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginTop: "24px",
    marginBottom: "48px",
  },
  label: {
    color: grey[200],
  },
}));

export default BulkEditStartTimeForm;
